<template>
    <div class="single-banner">
        <div id="banner" class="swiper-container">
            <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(item, index) in banner" :key="index">
                    <a :href="item.Link"><img :src="item.ImageUrl" :alt="item.Alt" :title="item.Title"></a>
                </div>
            </div>
            <div class="swiper-pagination" v-if="bannerAmount > 1"></div>
        </div>
    </div>
</template>

<script>
    import Swiper from 'swiper'
    export default {
        name: 'SingleBanner',
        props: ['bannerList'],
        data () {
            return {
                banner: [],
                isLoop: false,
                bannerAmount: 0
            }
        },
        watch: {
            'bannerList': function () {
                this.updateBanner()
                    .then(() => {
                        this.initBanner()
                    })
            }
        },
        methods: {
            updateBanner () {
                return new Promise(resolve => {
                    this.banner = this.bannerList
                    this.bannerAmount = this.banner.length
                    this.isLoop = this.bannerAmount > 1
                    resolve()
                })
            },
            initBanner () {
                new Swiper('#banner', {
                    pagination: {
                        el: '.swiper-pagination',
                        type: 'bullets',
                        bulletElement: 'span'
                    },
                    loop: this.isLoop,
                    autoplay: {
                        delay: 5000,
                        disableOnInteraction: false
                    }
                })
            }
        }
    }
</script>

<style lang="less" scoped>
    .single-banner{
        padding-top: 19px;
        .swiper-container{
            width: 100%;
            .swiper-slide{
                width: 948px;
                overflow: hidden;
                img{
                    width: 100%;
                }
            }
            .swiper-pagination{
                bottom: 7px;
                .swiper-pagination-bullet{
                    width: 14px;
                    height: 14px;
                    background: #d4dbde;
                    opacity: 1;
                }
                .swiper-pagination-bullet-active{
                    background: #fbc500;
                }
            }
        }
    }
</style>
